import { Component, OnDestroy, OnInit } from '@angular/core';
import {
    AuctionCatalogsService as AuctionsService,
    GetFeaturedAuctions200Response,
    GetFeaturedAuctions200ResponseAllOfDataInner,
    ListActiveHomepageBanners200Response,
} from '@viewbid/ts-angular-client';
import { Banner } from '@viewbid/ui';
import { VbSnackbarService } from '@viewbid/ui';
import { DeviceCheckService } from 'src/app/viewbid/shared/services/device-check.service';
import { Subject, takeUntil } from 'rxjs';
import { SocketService } from 'src/app/viewbid/shared/services/socket.service';
import { mapHomepageBanners } from '@/vb-utils/banner-ui-mapper.util';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'vb-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit, OnDestroy {
    public isLoading: boolean = true;
    public unableToLoad: boolean = false;
    featuredAuctions!: GetFeaturedAuctions200ResponseAllOfDataInner[];
    auctionsLoaded: number = 0;
    banners: Banner[] = [];
    private readonly destroy$ = new Subject<void>();

    constructor(
        private auctionService: AuctionsService,
        private snackbarService: VbSnackbarService,
        private deviceCheckService: DeviceCheckService,
        private socketService: SocketService,
        private translate: TranslateService,
    ) {
        this.fetchBanners();
        this.fetchFeaturedAuction();

        this.deviceCheckService.isSlow().then((isSlow: boolean) => {
            if (isSlow) {
                this.snackbarService.system(
                    this.translate.instant(
                        'Notifications.slowConnectionDetected',
                    ),
                );
            }
        });
    }

    fetchBanners(): void {
        this.auctionService.listActiveHomepageBanners(1, 10).subscribe({
            next: (res: ListActiveHomepageBanners200Response) => {
                this.banners = mapHomepageBanners(res.data);
            },
            // Banners are non-critical: on failure leave the list empty and the
            // component renders nothing.
            error: () => {
                this.banners = [];
            },
        });
    }
    ngOnInit(): void {
        // Reconnect REST backstop: refetch featured auctions on non-recovered reconnect.
        this.socketService.reconnected$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.fetchFeaturedAuction());
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    fetchFeaturedAuction(): void {
        this.isLoading = true;
        // TODO: Update the call to make use of query, once that is implemented in the backend
        this.auctionService.getFeaturedAuctions(1, 10).subscribe({
            next: (res: GetFeaturedAuctions200Response) => {
                this.isLoading = false;
                this.featuredAuctions = res.data;
            },
            error: ({ error }: any) => {
                this.isLoading = false;
                if (error.errorCode !== 1060) {
                    this.unableToLoad = true;
                }
            },
        });
    }
}
